var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import ErrorHandler from '@/support/ErrorHandler';
import _ from 'lodash';
let ProgressInterest = class ProgressInterest extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.interests = [];
        this.isEditingInterests = false;
        this.isUpdatingInterests = false;
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.portfolioClone = _.cloneDeep(this.portfolio);
        this.interests = this.portfolioClone.interests;
    }
    addInterest() {
        this.isEditingInterests = true;
        this.interests.push({
            name: this.$t('progress.interest.new').toString(),
        });
    }
    updateInterests() {
        const payload = {
            interests: this.interests.map((interest) => interest.name),
        };
        new PortfolioModel()
            .updateRelation(this.portfolio.id, 'interests', '', payload)
            .then(() => {
            this.isEditingInterests = false;
            this.$emit('portfolioUpdated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    removeInterest(name) {
        if (!this.interests) {
            return;
        }
        this.interests = this.interests.filter((interest) => {
            return interest.name !== name;
        });
    }
    resetInterests() {
        this.interests = _.cloneDeep(this.portfolio).interests;
        this.isEditingInterests = false;
    }
    get user() {
        return this.$store.state.Auth;
    }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.interest.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.updateInterests();
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdatingInterests = false;
                    },
                },
            },
        };
    }
};
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_a = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _a : Object)
], ProgressInterest.prototype, "portfolio", void 0);
ProgressInterest = __decorate([
    Component({
        components: {},
    })
], ProgressInterest);
export default ProgressInterest;
